export default __webpack_public_path__ + "static/media/mois-national-histoire-autochtone-2022.e605f0cf.jpeg";